module.exports = __webpack_public_path__ + "img/c11f206.png";